import { getDefaultArtifactRegistry } from './defaultRegistry';

function mergeProps(base, override) {
  if (!override) return base;
  return {
    ...base,
    ...override,
  };
}

export function createRenderProgramRunner(program, ctx, registry = getDefaultArtifactRegistry()) {
  const elements = Array.isArray(program?.elements) ? program.elements : [];
  const tracks = Array.isArray(program?.tracks) ? program.tracks : [];
  const clear = program?.clear || null;
  const durationSec =
    typeof program?.meta?.durationSec === 'number' ? Math.max(0, program.meta.durationSec) : null;

  const trackStates = tracks.map(() => ({}));
  let localTime = 0;
  let finalized = false;

  const renderFrame = () => {
    if (clear) {
      ctx.clearRect(clear.x, clear.y, clear.w, clear.h);
    }

    const dynamicByElement = Object.create(null);
    let allTracksDone = true;

    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      const anim = registry.getAnim(track.anim);
      if (!anim) continue;

      const trackResult = anim.eval({
        time: localTime,
        dt: 0,
        params: track.params || {},
        state: trackStates[i],
      });

      if (trackResult?.props && track.target) {
        dynamicByElement[track.target] = mergeProps(
          dynamicByElement[track.target],
          trackResult.props
        );
      }

      if (!trackResult?.done) {
        allTracksDone = false;
      }
    }

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const renderer = registry.getRenderer(element.renderer);
      if (!renderer) continue;
      const params = mergeProps(element.params || {}, dynamicByElement[element.id]);
      renderer.draw({ ctx, params, time: localTime });
    }

    return durationSec !== null ? localTime >= durationSec : allTracksDone;
  };

  return (dt) => {
    if (finalized) return false;

    localTime += dt;
    const done = renderFrame();
    if (!done) return true;

    if (durationSec !== null) {
      localTime = durationSec;
      renderFrame();
    } else {
      renderFrame();
    }

    finalized = true;
    return false;
  };
}

export function commitRenderProgram(packet, ctxs, anim, registry = getDefaultArtifactRegistry()) {
  if (!packet?.renderProgram) {
    throw new Error('commitRenderProgram requires packet.renderProgram');
  }
  const runner = createRenderProgramRunner(packet.renderProgram, ctxs.ink, registry);
  anim.add((dt) => runner(dt));
}
